<template lang="pug">
    .header.w-full.text-white
      
      .h-200.py-20.px-20.bgHeader
      
        .flex.justify-between.max-w-1366.m-auto
          .flex.items-center
            .mr-10()
              iCon.h-25.w-96(:iconClass="'logo'" type="svg" )
            .text-16.font-300.flex.items-center() 
              .font-20.cursor-pointer.font-500.leading-20.pt-4(@click="home()") {{$t('__common.__driverCommand')}}
              iCon.w-50.h-24.ml-12.text-white(:iconClass="'Ico_Beta'" type="svg" )
          .flex.items-center
            .ml-20.rounded-50.relative()
              .cursor-pointer(@click.stop="showLang()")
                iCon.h-24.w-24.inline-block.text-grey-e6(iconClass="ap_icon_language" type="svg" )
              .absolute.top-32.right-0.z-350.w-148.shadow-user(class="xl:right-0" v-if="infoIsShow" v-click-outside="outsideHandler")
                .bg-white.shadow-lg.rounded-4.overflow-hidden.text-black.py-8(v-if="showLangIcon")
                  .px-14.py-2.flex.justify-between.items-center.text-left.cursor-pointer(
                    v-for="(item, index) in lanType"
                    class="active:text-main-0  hover:text-main-0 "
                    @click="clickLan(item)")
                    //'bg-main-0':lanTypeSelect.id == item.id, 'text-white': lanTypeSelect.id == item.id,
                    .text-14.leading-24(
                      )  {{item.name}}
                    iCon.h-24.w-24.inline-block.-grey-e6(iconClass="check" type="svg" v-if="lanTypeSelect.id == item.id")
            
            .ml-20.rounded-50.cursor-pointer(@click.stop="showRelease()")
              iCon.h-24.w-24.text-white(iconClass="Icon_hit" type="svg"  )

          


            //- .border-r-2.border-white.pr-28.cursor-pointer   Assign Model 
            .ml-20.bg-grey-e6.rounded-50.cursor-pointer(@click.stop="showInfo()")

              iCon.h-25.w-25.inline-block.p-3(iconClass="user" type="svg")
</template>

<script>
import moment from "moment";

import { npsSetting } from "@/utils/globe";
import { mapMutations } from "vuex";
import {  getCookie, setCookie } from '../utils/cookies.js';
import { DOMAINURL, LANG } from '@/enum/global';

export default {
  name: "Header",
  components: {},
  props: {},
  inject: ["reload"], //註入依賴 //detail頁面原頁刷新的相關內容
  data() {
    return {
      infoIsShow: true,
      lanTypeSelect: {},
      lanType: [
        { name: "English ", id: "en" },
        { name: "繁體中文", id: "tw" },
        { name: "Français", id: "fr" },
        { name: "ภาษาไทย", id: "th" },
        { name: "日本語", id: "ja" },
        { name: "简体中文", id: "zh" },
        { name : 'Português', id : 'pt_rbr'},
      ],
      showLangIcon: false,
      apiError: undefined
    };
  },
  mixins: [npsSetting],
  created() {
    // console.log(this.$store.state.user.user,'user')
    // if (process.env.VUE_APP_ENV == "test" || process.env.VUE_APP_ENV == "mock") {
    //   // this.lanType.push({ name: "lang", id: "variable" });
    // }
    this.checkCurrentLang();
  },
  async mounted() {},
  methods: {
    ...mapMutations({
      setUserInfo: "user/setUserInfo"
    }),
    home() {
      this.$router.push({ path: "/" }).catch(err => err);
      //, name:'Ui' , params:{id:122}
    },
    closeAll() {
      this.showLangIcon = false;
    },
    showInfo() {
      this.closeAll();
      this.$emit("closeUser");
    },
    showRelease() {
      this.closeAll();
      this.$emit("releaseNote");
    },
    showLang() {
      this.closeAll();
      this.showLangIcon = true;
    },
    clickLan(e) {
      this.lanTypeSelect = e;
      this.$store.commit("user/setLangIsSelected", this.lanTypeSelect.id);
      let  currentDomain = ''
      if(process.env.VUE_APP_ENV == 'test' || process.env.VUE_APP_ENV == 'mock' ){
        currentDomain = window.location.hostname;
      }else{
        currentDomain = DOMAINURL[this.$store.state.setting.env];
      }
      console.log('當前 domain:',this.$store.state.setting.env ,DOMAINURL[this.$store.state.setting.env], process.env.VUE_APP_ENV, );
      let date = new Date();
      // let value = LANG[this.lanTypeSelect.id] ? LANG[this.lanTypeSelect.id] : this.lanTypeSelect.id; 
      let value = typeof (LANG[this.lanTypeSelect.id]) !== 'undefined' ? LANG[this.lanTypeSelect.id] : LANG.en; 
      document.documentElement.setAttribute("lang", value);
      const expires = 365 * 10;
      date.setTime(date.getTime() + expires * (24 * 60 * 60 * 1000));
      const isSecure = window.location.protocol === 'https:';
      const sameSiteValue = isSecure ? 'None' : 'Lax';
      document.cookie = `cpp_langCountry=${value}; expires=${date.toUTCString()}; domain=${currentDomain}; path=/; SameSite=${sameSiteValue}${isSecure ? '; secure' : ''}`;
      console.log('document.cookie:', `cpp_langCountry=${value}; expires=${date.toUTCString()}; domain=${currentDomain}; path=/; SameSite=${sameSiteValue}${isSecure ? '; secure' : ''}`);

    },
    outsideHandler() {
      this.showLangIcon = false;
    },
    checkCurrentLang() {
      this.lanTypeSelect.id = getCookie('cpp_langCountry'); 
      // 轉換成LANG[key], 再對回Header的lanType
      this.lanTypeSelect.id = Object.keys(LANG).find(key => LANG[key] === this.lanTypeSelect.id);
      if (typeof this.lanTypeSelect.id == 'undefined') {
        // 參考該頁lanType選單
        this.lanTypeSelect = { name: "English", id: "en" };
      } else {
        this.lanTypeSelect = this.lanType.filter(obj => {
          return obj.id == this.lanTypeSelect.id;
        })[0]
      }
      
      console.log('this.lanTypeSelect',this.lanTypeSelect)
      this.$store.commit("user/setLangIsSelected", this.lanTypeSelect.id);
      this.clickLan(this.lanTypeSelect)
    }
  },
  computed: {},
  watch: {
   lanTypeSelect:{
      handler:function(e){ 
        this.$i18n.locale = e.id;
      },
      deep:true,
    },
    '$store.state.setting.env': function() {
      this.checkCurrentLang()
    }

  }
};
</script>

<style lang="scss" scoped>
.bgHeader {
  background-size: cover;
  // background-position: right;
  background-image: url("~@/assets/pic/driver-repack-img-background.png");
}
</style>
